<script setup>
import { computed, onUnmounted } from "vue";
import { useQuizEmojiStore } from "@/stores/storeQuizEmoji";
import { useRequestsStore } from "@/stores/storeRequests";
import { sendMetrik } from '@/utils/metrika'
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";
const storeQuizEmoji = useQuizEmojiStore();
const storeRequests = useRequestsStore();

const textBtn = computed(() => (storeRequests.isAuthenticated ? "Загрузить чек" : "Зарегистрироваться"));
onUnmounted(() => {
	storeQuizEmoji.restartGame();	
	sendMetrik('reachGoal', 'Emojis_fin')
})
</script>
<template>
	<div :class="['quiz-end-game', { '--assecs': storeQuizEmoji.isShowResultGame }]">
		<div class="container">
			<div class="quiz-end-game__container">
				<div class="quiz-end-game__block" v-if="storeQuizEmoji.isShowResultGame">
					<h2 class="quiz-end-game__title">{{ storeQuizEmoji.finishData.header }}</h2>
					<div class="quiz-end-game__box">
						<p >{{ storeQuizEmoji.finishData.text }}</p>
						<BaseButtonUploadReceipt  class="quiz-end-game__btn --blue">{{ textBtn }}</BaseButtonUploadReceipt>
					</div>
				</div>

				<div class="quiz-end-game__block" v-else>
                    <h2 class="quiz-end-game__title">{{ storeQuizEmoji.finishData.header }}</h2>
					<p class="quiz-end-game__subtitle">{{ storeQuizEmoji.finishData.text }}</p>
                    <button class="quiz-end-game__btn btn --blue" @click="storeQuizEmoji.restartGame()">Пройти еще раз</button>
					<!-- <BaseButtonUploadReceipt v-else  class="quiz-end-game__btn --blue">Зарегистрироваться</BaseButtonUploadReceipt> -->
                </div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-end-game {
    position: relative;
	padding: 8rem 0 15rem;
	color: #fff;
	background-image: url("@/assets/img/games/game_line_1.webp"), url("@/assets/img/games/game_line_2.webp");
	background-repeat: no-repeat;
	background-position: 0% 0%, 100% 100%; /* x y*/
	background-size: 16%, 18%;
	@media (max-width: vars.$xx) {
		background-image: none;
		padding: 4.5rem 0 7rem;
	}

	&.--assecs {
		background-image: url("@/assets/img/games/game_line_0.webp"), url("@/assets/img/games/game_line_2.webp");
		background-repeat: no-repeat;
		background-position: 0% 61%, 100% 100%; /* x y*/
		background-size: 34%, 18%;
		@media (max-width: vars.$xx) {
			background-image: none;
		}
        .quiz-end-game__box {

            &::before {
                position: absolute;
                content: '';
                background-image: url('@/assets/img/games/game_gift.webp');
                background-repeat: no-repeat;
                background-position: 0px 0px; /* x y*/
                background-size: contain; /* w h*/
                width: 44rem;
                height: 44rem;
                right: -34%;
                bottom: -34%;
                z-index: 1;
                @media (max-width: vars.$mn) {
                    width: 30rem;
                    height: 30rem;
                    right: -13%;
                    bottom: -25%;
                }
                @media (max-width: vars.$xx) {
                    display: none;
                }
            }
        }
        .quiz-end-game__container {
            max-width: 82.2rem;
        }
	}
}

.quiz-end-game__container {
	display: flex;
	align-items: center;
    justify-content: center;
	flex-direction: column;
    max-width: 99.6rem;
    margin: 0 auto;
}
.quiz-end-game__block {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.quiz-end-game__title {
	font-weight: 700;
	font-size: 7.2rem;
	line-height: 140%;
	text-transform: uppercase;
	text-align: center;
	margin-bottom: 2.2rem;
    @media (max-width: vars.$x480) {
		font-size: 3.4rem;
	}
}
.quiz-end-game__subtitle {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	text-align: center;	
	margin-bottom: 5rem;
    @media (max-width: vars.$x480) {
        font-size: 2rem;
    }
}
.quiz-end-game__box {
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;
    gap: 4rem;
	border-radius: 3.2rem;
    padding: 5.5rem 5.8rem;
	background: var(--system-fill-light);
	color: var(--text-accent-1-100);
	text-align: center;
    @media (max-width: vars.$x480) {
        padding: 40px 30px;
        border-radius: 2rem;
        gap: 2rem;
    }
	h3 {
		font-weight: 500;
		font-size: 3.2rem;
		line-height: 120%;
        @media (max-width: vars.$x480) {
            font-size: 2.4rem;
        }
	}
	p {
		font-weight: 400;
		font-size: 2.4rem;
		line-height: 140%;
        @media (max-width: vars.$x480) {
            font-size: 1.8rem;
        }
	}
}
.quiz-end-game__btn {
}
.--blue {
}
</style>
